import { jsx } from "react/jsx-runtime";
import { token } from "./token.js";
import { SvgIcon } from "./styles2.js";
const statusIcons = {
  online: OnlineIcon,
  offline: OfflineIcon,
  inactive: InactiveIcon
};
function Status({
  type
}) {
  const Icon = statusIcons[type];
  return /* @__PURE__ */ jsx(Icon, {
    "data-thumbnail-status": true
  });
}
function OnlineIcon({
  ...props
}) {
  return /* @__PURE__ */ jsx(SvgIcon, {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fill: token.teal500,
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 Z M 0 12 "
    })
  });
}
function OfflineIcon({
  ...props
}) {
  return /* @__PURE__ */ jsx(SvgIcon, {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fill: token.gray400,
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 Z M 0 12 "
    })
  });
}
function InactiveIcon({
  ...props
}) {
  return /* @__PURE__ */ jsx(SvgIcon, {
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fill: "transparent",
    ...props,
    children: /* @__PURE__ */ jsx("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      stroke: token.gray400,
      strokeWidth: "4"
    })
  });
}
export {
  Status
};
//# sourceMappingURL=Status.js.map
